import {
  SET_FORECAST_CASH_TO_EARNING,
} from "./mutations";

const initialState = {
  forecastCashToEarnings: null
};

const forecastCashToEarningReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_FORECAST_CASH_TO_EARNING:
      return { ...state, forecastCashToEarnings: payload }

    default:
      return state;
  }
};

export default forecastCashToEarningReducer;
